import { useEffect, useState} from "react";
import {useNavigate, useOutletContext, useSearchParams} from "react-router-dom";
import venifyLogo from "../../venifyLogo.png"
import Api from "../../tools/service";
import Container from "../../components/Container";

import LoadingScreen from "../../components/LoadingScreen";
import {MdAlternateEmail} from "react-icons/md";
import {TbWorldWww} from "react-icons/tb";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/Authentication";
import WidgetRules from "./WidgetRules";
import {RiAlertFill} from "react-icons/ri";

const IAuthReports=()=>{
    const [token,setToken] = useOutletContext();

    const [info,setInfo]=useState(null);
    const [loading,setLoading]=useState(true)
    const [AuthDate,setAuthDate]=useState()
    const [searchParams] = useSearchParams();
    const ref=searchParams.get('ref');

    const navigate=useNavigate();
 /*   useEffect(()=>{

        if(token){
            getReports()
        }
    },[token]);*/
    useEffect(() => {
        getReports()
    }, []);
    const getReports=()=>{

        setLoading(true)
        Api.get(`api/v1/Public/DivarInternalAuth/${ref}`,{
            params:{
                g_response:token,
            }
        }).then(response=>{

            if(!response.hasError){

                setInfo(response.data)

                const date = new Date(response.data.auth_date * 1000);
                const formatter = new Intl.DateTimeFormat('fa-IR', {
                    month:"long",
                    day:"numeric",
                    calendar:"persian",
                    year:"numeric"
                });
                setAuthDate(formatter.format(date))
            }else{
               /* navigate('/notfound')*/
            }
        }).catch(e=>{

        }).finally(()=>{
            setLoading(false)
        })
    }
    if(loading){
        return  <LoadingScreen/>
    }



    function imageData(str) {
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

        if(urlRegex.test(str)){
            return str;
        }else {

            return "data:image/png;base64,"+str
        }
         ;
    }

    return <div className="  ">
        <Container className="flex  font-sm rtl mt-5 lg:mt-16  items-center  flex-col justify-center">
            <div className=" items-center w-full mb-2 rounded-xl  flex bg-white p-5  ">
                <a className="w-16" href="https://venify.ir">
                    <img className="w-16" src={venifyLogo} alt=""/>
                </a>
                <div className="flex mr-2 flex-col">
                    <a href="https://venify.ir">
                        <h1 className="text-xl    font-bold  ">ونیفای</h1>
                    </a>
                    <p className="  text-sm  "> ارائه دهنده سرویس‌های هوشمند مالی و بانکی در جهت سهولت و مجازی‌سازی خدمات</p>
                </div>
            </div>
            <div dir="rtl" className="w-full flex   flex-col lg:grid lg:grid-cols-6   lg:flex-row lg:items-stretch lg:gap-2 ">

                {info && <div
                    className="w-full bg-white lg:col-span-2 flex flex-col justify-between  mb-3 lg:mb-0  p-5 rounded-xl  ">
                    <div className="w-full flex justify-start items-center  p-3">
                        <img
                            src={info?.widget_body?.face_img && !info?.deleted_widgets?.includes(AuthenticationDefaultSteps.IAuth) ? imageData(info?.widget_body?.face_img) : info.widget_body?.def_user_img_url}
                            className="w-16 border   h-auto" alt=""/>
                        <div className="mr-3 flex flex-col">
                            <strong>{info?.widget_body?.full_name}</strong>
                            <span className="text-sm ">{info?.widget_body?.person_section_sub_title}</span>
                        </div>


                    </div>
                    <div className="flex justify-start gap-2 items-center   border-dashed border-yellow-500 border-2 p-3 rounded-lg bg-yellow-50 text-yellow-700">
                        <RiAlertFill size={30} className="border-yellow-500" />
                        <p className="text-sm">
                            این اطلاعات نباید مبنای اعتماد یا کارت‌به‌کارت وجه شود
                        </p>
                    </div>
                    <div
                        className="flex items-start  flex-col  justify-start   pt-3 mt-3  ">
                        <div
                            className="   w-full md:w-auto mb-2 pb-2 border-b text-sm  rounded-lg justify-start md:flex-col md:mb-0  ">
                            <span>تاریخ  درج افزونه: </span>
                            <span>{AuthDate}</span>
                        </div>
                        {info?.btns?.map((btn, index) => {
                            return <a href={btn.url} className="w-full " key={index}>
                                <button className="p-3 btn btn-green w-full  text-sm   px-5 rounded-lg  ">
                                    {btn?.title}
                                </button>
                            </a>
                        })}
                    </div>

                </div>}
                <WidgetRules/>

            </div>
            <div dir="rtl"
                 className="w-full    mt-4 text-sm      text-center flex justify-center items-center flex-col ">
                <div className="grid grid-cols-2 lg:grid-cols-2  w-full  gap-3 ">
                    <div className=" p-5 col-span-1 bg-white flex justify-start items-center text-gray-800 rounded-xl">
                        <TbWorldWww className="text-xl"/>
                        <div className="flex  mr-3 flex-col items-start justify-start">
                            <p className="text-gray-800 mb-1">آدرس وبسایت</p>
                            <a href="https://venify.ir" className="text-gray-800 font-bold">https://venify.ir</a>
                        </div>
                    </div>
                    <div className=" p-5 col-span-1 bg-white flex justify-start  items-center text-gray-800 rounded-xl">
                        <MdAlternateEmail className="text-xl"/>
                        <div className="flex mr-3 flex-col items-start justify-start">

                            <p className="text-gray-700 text-sm mb-1">ایمیل</p>
                            <a href="mailto:info@venify.ir" className=" font-bold">info@venify.ir</a>
                        </div>
                    </div>

                    {/*     <div className="bg-gray-100 p-5 col-span-2  lg:col-span-3 flex justify-start items-center text-gray-800 rounded-xl">
                    <FaLocationArrow/>
                    <div className="flex mr-3 flex-col items-start justify-start">
                        <p className="text-gray-800 mb-1">آدرس</p>
                        <p className="text-gray-800 font-bold">مازندران،بابل،چهارراه توحید شرکت عصرداده</p>
                    </div>
                </div>*/}

                </div>
                <div className="w-full border-t mt-5 "></div>
                <p className="mt-2 text-sm ">تمامی حقوق مربوط به این وب‌سایت، متعلق به شرکت <a
                    className="text-red-600 font-bold" href="https://asredade.com">عصرداده</a> می باشد.</p>
            </div>
        </Container>



    </div>
}
export default IAuthReports;